export default __webpack_public_path__ + "static/media/lpg-transmission-500x500.36b1a96b.png";